// ---------------------------------------------------------------------------
// LucidTopup - Mock dataset
// ---------------------------------------------------------------------------
// ข้อมูลจำลองทั้งหมดของหน้าเว็บ (เกม / บัตร / มือถือ / สินค้า / โปรโมชั่น / ประวัติ)
// เมื่อ Backend พร้อม ไฟล์นี้จะถูกใช้เฉพาะตอน USE_MOCK = true เท่านั้น
// ---------------------------------------------------------------------------

// โหลดรูปเกมทั้งหมดใน assets/images/game
const gameImageContext = require.context("../assets/images/game", false, /\.png$/);
const GAME_IMAGES = gameImageContext.keys().sort().map((key) => gameImageContext(key));

const mobileImageContext = require.context("../assets/images/mobile", false, /\.(png|jpg)$/);
const MOBILE_IMAGES = mobileImageContext.keys().sort().map((key) => mobileImageContext(key));

const img = (index) => GAME_IMAGES[index % GAME_IMAGES.length];

const slugify = (text) =>
  text
    .toLowerCase()
    .replace(/[()]/g, "")
    .replace(/[^a-z0-9ก-๙]+/g, "-")
    .replace(/^-+|-+$/g, "");

// --------------------------------------------------------------------------
// ประกาศ / แบนเนอร์ / ช่องทางชำระเงิน
// --------------------------------------------------------------------------
export const ANNOUNCEMENTS = [
  "ประกาศ !! วันที่ 01/09/2026 ปรับราคาแพ็กเกจ Aether Legends ขึ้น 5% แนะนำเติมเก็บไว้ก่อนได้เลย",
  "LucidTopup เปิดบริการ 24 ชม. ทีมงานพร้อมดูแลทุกคำสั่งซื้อ",
];

export const HERO_SHORTCUTS = [
  { id: "uid", title: "เติมเกมออนไลน์", subtitle: "ระบบ UID และ ID PASS", to: "/topup/game", images: [img(1), img(12), img(23)] },
  { id: "card", title: "บัตรเติมเงิน", subtitle: "Game online TOP-UP", to: "/topup/card", images: [img(34), img(45), img(56)] },
  { id: "mobile", title: "เติมเงินมือถือ", subtitle: "Mobile TOP-UP", to: "/topup/mobile", images: [MOBILE_IMAGES[0], MOBILE_IMAGES[1], MOBILE_IMAGES[2]] },
];

export const PAYMENT_CHANNELS = [
  {
    group: "QR payment",
    items: [
      { id: "qr", name: "QR Payment", badge: "ค่าธรรมเนียม 1.5 %", feeRate: 0.015, tone: "warning", logoText: "THAI QR", logoSub: "PAYMENT" },
    ],
  },
];

// ช่องทางชำระเงินสำหรับหน้าสั่งซื้อ - ใช้ QR Payment อย่างเดียว
export const ORDER_PAYMENT_CHANNELS = [
  { id: "qr", name: "QR Payment", badge: "ค่าธรรมเนียม 1.5 %", feeRate: 0.015, tone: "warning", logoText: "THAI QR", logoSub: "PAYMENT" },
];

// --------------------------------------------------------------------------
// เกม
// --------------------------------------------------------------------------
const GAME_NAMES = [
  "Aether Legends", "Crystal Odyssey", "Neon Blade Arena", "Sky Realm Saga", "Chrono Fracture",
  "Dragon Vanguard", "Lucid Frontier", "Shadow Verdict", "Prism Warriors", "Titan Gate",
  "Astral Rift", "Iron Covenant", "Mystic Harvest", "Velocity Strike", "Solaris Tactics",
  "Echo Hunters", "Rune Cascade", "Phantom Circuit", "Blaze Kingdom", "Orbital Siege",
  "Verdant Chronicle", "Nova Requiem", "Storm Lancer", "Twilight Bastion", "Quantum Duel",
  "Gilded Empire", "Frost Mandate", "Ember Reverie", "Silent Horizon", "Zenith Clash",
  "Arcane Ledger", "Radiant Vow", "Obsidian Trail", "Halcyon Guard", "Pulse Reactor",
  "Wildcard Royale", "Lumen Odyssey", "Sable Dominion", "Meteor Brigade", "Tidal Crown",
  "Spirit Anvil", "Vortex Legion", "Aurora Tactics", "Crimson Ascent", "Glacier Front",
  "Mirage Protocol", "Starfall Guild", "Thunder Relic", "Umbra Wars", "Zephyr Trials",
  "Cobalt Sentinel", "Dawnbreaker", "Elysium Drift", "Fable Machina", "Grimoire Online",
  "Havoc Ronin", "Ivory Bastion", "Jade Cipher", "Kinetic Vanguard", "Lunar Edict",
  "Monarch Reign", "Nether Spark", "Oath of Ashes", "Pyre Legacy", "Quasar Knights",
  "Rift Custodian", "Sanctum Wars", "Terra Nomad", "Ultra Genesis", "Valkyrie Line",
  "Warden Protocol", "Xenon Blitz", "Yggdra Legends", "Zircon Saga", "Aegis Overdrive",
  "Bolt Runner", "Cygnus Front",
];

const CURRENCY_BY_TYPE = {
  uid: "เพชร",
  idpass: "คูปอง",
  card: "รหัสบัตร",
};

const buildPackages = (seed, currency) => {
  const steps = [11, 24, 60, 110, 185, 370, 620, 1240];
  return steps.map((step, i) => {
    const amount = step + (seed % 5) * (i + 1);
    const price = Math.round(amount * (0.78 + ((seed % 7) / 100)));
    return {
      id: `${seed}-pkg-${i + 1}`,
      name: `${amount.toLocaleString()} ${currency}`,
      amount,
      price,
      oldPrice: i % 3 === 0 ? Math.round(price * 1.12) : null,
      bonus: i >= 5 ? `+ โบนัส ${Math.round(amount * 0.05)} ${currency}` : null,
    };
  });
};

export const GAMES = GAME_NAMES.map((name, index) => {
  const type = index % 3 === 0 ? "idpass" : "uid";
  const server = index % 9 === 0 ? "other" : "th";
  return {
    id: 1000 + index,
    name,
    slug: slugify(name),
    image: img(index),
    banner: img((index + 9) % GAME_IMAGES.length),
    type, // uid | idpass
    server, // th | other
    instant: index % 4 !== 0,
    promo: index % 6 === 0,
    available: index % 17 !== 0,
    popular: index < 12,
    currency: CURRENCY_BY_TYPE[type],
    inputs:
      type === "uid"
        ? [{ key: "openId", label: "Open ID", placeholder: "กรอก Open ID (แบบสั้นเท่านั้น)" }]
        : [
            { key: "username", label: "Username / ID", placeholder: "กรอกไอดีสำหรับเข้าเกม" },
            { key: "password", label: "Password", placeholder: "กรอกรหัสผ่าน", type: "password" },
          ],
    note: "กรุณาตรวจสอบข้อมูลก่อนยืนยัน ระบบไม่สามารถคืนเงินได้ทุกกรณี",
    packages: buildPackages(index + 3, CURRENCY_BY_TYPE[type]),
  };
});

// --------------------------------------------------------------------------
// เติมเงินมือถือ
// --------------------------------------------------------------------------
export const MOBILE_OPERATORS = [
  { id: 2001, name: "เติมเงินมือถือ Lucid-One", slug: "lucid-one", image: MOBILE_IMAGES[0] },
  { id: 2002, name: "เติมเงินมือถือ Lucid-Wave", slug: "lucid-wave", image: MOBILE_IMAGES[1] },
  { id: 2003, name: "เติมเงินมือถือ Lucid-Net", slug: "lucid-net", image: MOBILE_IMAGES[2] },
  { id: 2004, name: "เติมเงินมือถือ Lucid-Link", slug: "lucid-link", image: MOBILE_IMAGES[3] },
].map((operator, index) => ({
  ...operator,
  banner: img(index + 40),
  available: true,
  inputs: [{ key: "phone", type: "tel", label: "เบอร์โทรศัพท์", placeholder: "กรอกเบอร์โทรศัพท์ 10 หลักที่ต้องการเติม" }],
  note: "ยอดเงินจะเข้าเบอร์ภายใน 1-3 นาทีหลังชำระเงินสำเร็จ",
  packages: [20, 50, 100, 150, 200, 300, 500, 1000].map((amount, i) => ({
    id: `${operator.id}-pkg-${i + 1}`,
    name: `เติมเงิน ${amount} บาท`,
    amount,
    price: amount + Math.round(amount * 0.03),
    oldPrice: null,
    bonus: null,
  })),
}));

// --------------------------------------------------------------------------
// บัตรเติมเงิน
// --------------------------------------------------------------------------
export const CARDS = [
  { id: 3001, name: "Lucid Wallet Code", slug: "lucid-wallet-code", imageIndex: 5 },
  { id: 3002, name: "Prism Pin TH", slug: "prism-pin-th", imageIndex: 16 },
  { id: 3003, name: "Zenith Gold", slug: "zenith-gold", imageIndex: 27 },
  { id: 3004, name: "บัตร Lucid Money", slug: "lucid-money", imageIndex: 38 },
  { id: 3005, name: "Nova Play Card", slug: "nova-play-card", imageIndex: 49 },
  { id: 3006, name: "Orbit Game Card", slug: "orbit-game-card", imageIndex: 60 },
].map((card) => ({
  ...card,
  image: img(card.imageIndex),
  banner: img(card.imageIndex + 3),
  available: true,
  note: "รหัสบัตรจะแสดงในหน้าประวัติสั่งซื้อบัตรเติมเงินทันทีที่ชำระเงินสำเร็จ",
  inputs: [],
  packages: [100, 200, 300, 500, 1000, 1500].map((amount, i) => ({
    id: `${card.id}-pkg-${i + 1}`,
    name: `${card.name} ${amount} บาท`,
    amount,
    price: Math.round(amount * 0.97),
    oldPrice: amount,
    bonus: null,
  })),
}));

// --------------------------------------------------------------------------
// สินค้า (Gaming gear)
// --------------------------------------------------------------------------
export const PRODUCT_CATEGORIES = [
  { id: 0, name: "สินค้าล่าสุด" },
  { id: 1, name: "เมาส์" },
  { id: 2, name: "คีย์บอร์ด" },
  { id: 3, name: "หูฟัง" },
  { id: 4, name: "ไมโครโฟน" },
  { id: 5, name: "แท่นวางหูฟัง" },
  { id: 6, name: "แผ่นรองเมาส์" },
];

const PRODUCT_SEED = [
  { name: "Lucid Viper V3 Pro (สีขาว /สีดำ)", price: 2900, categoryId: 1 },
  { name: "Lucid Basilisk V3 Pro (สีขาว /สีดำ)", price: 2500, categoryId: 1 },
  { name: "Lucid Cobra Pro (สีขาว /สีดำ)", price: 2500, categoryId: 1 },
  { name: "Lucid Naga V2 Pro (สีดำ)", price: 4000, categoryId: 1 },
  { name: "Lucid Mecha K70 Wireless", price: 3200, categoryId: 2 },
  { name: "Lucid Tenkey Pro RGB", price: 2100, categoryId: 2 },
  { name: "Lucid Aurora 75% Hotswap", price: 3900, categoryId: 2 },
  { name: "Lucid Beam Headset 7.1", price: 2790, categoryId: 3 },
  { name: "Lucid Halo Wireless Headset", price: 4590, categoryId: 3 },
  { name: "Lucid Voice Mic Studio", price: 3490, categoryId: 4 },
  { name: "Lucid Voice Mic Mini", price: 1690, categoryId: 4 },
  { name: "Lucid Headset Stand RGB", price: 990, categoryId: 5 },
  { name: "Lucid Deskpad XL", price: 690, categoryId: 6 },
  { name: "Lucid Deskpad Glass", price: 1290, categoryId: 6 },
];

export const PRODUCTS = PRODUCT_SEED.map((item, index) => ({
  id: 4001 + index,
  name: item.name,
  slug: slugify(item.name),
  price: item.price,
  categoryId: item.categoryId,
  stock: (index % 5) + 1,
  images: [img(index + 20), img(index + 21)],
  options: [
    { id: "white", label: "สีขาว", color: "#ffffff" },
    { id: "black", label: "สีดำ", color: "#111827" },
  ],
  description: ["- ประกัน 2 ปี", "- สินค้าแท้ 100 %"],
  createdAt: `2026-0${(index % 8) + 1}-1${index % 9}`,
}));

// --------------------------------------------------------------------------
// โปรโมชั่น
// --------------------------------------------------------------------------
export const PROMOTIONS = [
  {
    id: 5001,
    title: "Lucid Accessories \"ของแท้ 100%\" พร้อมส่งตรงถึงมือ",
    updatedAt: "2026-07-24 01:29:22",
    cover: img(2),
    excerpt: "รวมเกมมิ่งเกียร์ราคาพิเศษ พร้อมประกันศูนย์ไทย 2 ปี ส่งฟรีทั่วประเทศ",
    content: [
      "โปรโมชั่นสินค้าเกมมิ่งเกียร์ในเครือ LucidTopup ลดสูงสุด 30% ตลอดเดือนนี้",
      "สินค้าทุกชิ้นเป็นของแท้ 100% พร้อมใบรับประกันศูนย์ไทย",
      "สั่งซื้อครบ 2,000 บาท รับเครดิตคืนเข้ากระเป๋า 3% ทันที",
    ],
  },
  {
    id: 5002,
    title: "เติมเงินกับ LucidTopup ผ่าน Lucid Wallet รับโบนัสทันที",
    updatedAt: "2026-07-17 10:01:46",
    cover: img(13),
    excerpt: "เติมเครดิตผ่าน Lucid Wallet รับโบนัสเพิ่ม 5% ทุกยอด ไม่จำกัดจำนวนครั้ง",
    content: [
      "เติมเครดิตขั้นต่ำ 100 บาทผ่าน Lucid Wallet รับโบนัสเพิ่ม 5% เข้ากระเป๋าทันที",
      "ใช้ได้ทุกวัน ไม่จำกัดจำนวนครั้งต่อผู้ใช้",
      "โบนัสสามารถใช้ซื้อแพ็กเกจเกมและสินค้าได้ทุกประเภท",
    ],
  },
  {
    id: 5003,
    title: "Aether Legends แจกโค้ดส่วนลดรับต้นเดือน",
    updatedAt: "2026-07-17 10:03:54",
    cover: img(24),
    excerpt: "กรอกโค้ด LUCID10 ลดทันที 10% สำหรับแพ็กเกจ Aether Legends ทุกแพ็ก",
    content: [
      "ใช้โค้ด LUCID10 ที่หน้าสั่งซื้อ Aether Legends ลดทันที 10%",
      "จำกัด 1 สิทธิ์ต่อผู้ใช้ต่อวัน",
      "ใช้ได้ถึงวันที่ 30 กันยายน 2026 เท่านั้น",
    ],
  },
  {
    id: 5004,
    title: "ชวนเพื่อนเติมเกม รับเครดิตฟรีทั้งคู่",
    updatedAt: "2026-06-30 18:22:10",
    cover: img(35),
    excerpt: "แชร์ลิงก์ชวนเพื่อน เมื่อเพื่อนเติมครั้งแรกรับเครดิตฟรีคนละ 50 บาท",
    content: [
      "คัดลอกลิงก์ชวนเพื่อนจากหน้าโปรไฟล์",
      "เมื่อเพื่อนสมัครและเติมเครดิตครั้งแรกครบ 200 บาท รับเครดิตฟรีคนละ 50 บาท",
      "จำกัดสูงสุด 10 สิทธิ์ต่อบัญชี",
    ],
  },
];

// --------------------------------------------------------------------------
// โปรไฟล์ + ประวัติ
// --------------------------------------------------------------------------
export const MOCK_PROFILE = {
  uid: "LT9F3KQ2",
  fullname: "Lucid Member",
  email: "member@lucidtopup.com",
  phone: "0992351149",
  countryCode: "+66",
  avatar: null,
  rank: 1,
  rankName: "rank 1",
  exp: 24500,
  expMax: 100000,
  credit: 1850.75,
  point: 320,
  memberSince: "2026-01-18 01:33:37",
  kycStatus: "pending",
};

const statusPool = ["success", "pending", "failed"];

const buildHistory = (prefix, count, mapper) =>
  Array.from({ length: count }).map((_, index) => ({
    id: `${prefix}-${index + 1}`,
    code: `${prefix.toUpperCase()}${(20260817 + index).toString().slice(-8)}`,
    status: statusPool[index % statusPool.length],
    createdAt: `2026-08-${String((index % 28) + 1).padStart(2, "0")} ${String((index % 23) + 1).padStart(2, "0")}:${String((index * 7) % 60).padStart(2, "0")}`,
    ...mapper(index),
  }));

export const CREDIT_HISTORY = buildHistory("cr", 14, (i) => ({
  channel: ["QR Payment", "True Money", "Razer Gold", "บัตรเครดิต"][i % 4],
  amount: [100, 300, 500, 1000, 2000][i % 5],
  fee: i % 4 === 0 ? 0 : Math.round([100, 300, 500, 1000, 2000][i % 5] * 0.2),
  note: "-",
}));

export const GAME_HISTORY = buildHistory("gm", 12, (i) => ({
  gameName: GAMES[i % GAMES.length].name,
  packageName: GAMES[i % GAMES.length].packages[i % 8].name,
  quantity: (i % 3) + 1,
  amount: GAMES[i % GAMES.length].packages[i % 8].price,
  note: "-",
}));

export const MOBILE_HISTORY = buildHistory("mb", 9, (i) => ({
  operator: MOBILE_OPERATORS[i % MOBILE_OPERATORS.length].name,
  phone: "09" + String(10000000 + i * 137).slice(0, 8),
  amount: [20, 50, 100, 200, 500][i % 5],
  note: "-",
}));

export const CARD_HISTORY = buildHistory("cd", 8, (i) => ({
  cardName: CARDS[i % CARDS.length].name,
  serial: `LT-${1000 + i}-${5000 + i * 3}`,
  pin: `••••-••••-${(1234 + i).toString()}`,
  amount: [100, 200, 300, 500][i % 4],
  note: "-",
}));

export const PRODUCT_HISTORY = buildHistory("pd", 6, (i) => ({
  productName: PRODUCTS[i % PRODUCTS.length].name,
  quantity: (i % 2) + 1,
  amount: PRODUCTS[i % PRODUCTS.length].price,
  shipping: ["กำลังจัดส่ง", "จัดส่งสำเร็จ", "รอชำระเงิน"][i % 3],
  tracking: `TH${9000000 + i * 17}`,
  note: "-",
}));

export const LOGIN_HISTORY = buildHistory("lg", 10, (i) => ({
  ip: `183.88.${100 + i}.${20 + i * 3}`,
  device: ["Chrome / macOS", "Safari / iOS", "Chrome / Windows", "Edge / Windows"][i % 4],
  location: ["Chonburi, TH", "Bangkok, TH", "Chiang Mai, TH"][i % 3],
  status: "success",
}));

export const SUPPORT_TICKETS = [
  {
    id: 6001,
    code: "TK-260817-001",
    subject: "เติมเกม Aether Legends แล้วยอดไม่เข้า",
    category: "เติมเกม",
    status: "open",
    createdAt: "2026-08-16 21:04",
    updatedAt: "2026-08-17 09:12",
    messages: [
      { from: "user", text: "เติมแพ็ก 620 เพชร แล้วยอดยังไม่เข้าครับ", at: "2026-08-16 21:04" },
      { from: "admin", text: "ทีมงานกำลังตรวจสอบให้นะครับ รบกวนรอสักครู่", at: "2026-08-17 09:12" },
    ],
  },
  {
    id: 6002,
    code: "TK-260810-014",
    subject: "ขอใบเสร็จการสั่งซื้อสินค้า",
    category: "สินค้า",
    status: "closed",
    createdAt: "2026-08-10 11:20",
    updatedAt: "2026-08-11 10:02",
    messages: [
      { from: "user", text: "ขอใบเสร็จคำสั่งซื้อ PD-4 ครับ", at: "2026-08-10 11:20" },
      { from: "admin", text: "ส่งใบเสร็จให้ทางอีเมลเรียบร้อยแล้วครับ", at: "2026-08-11 10:02" },
    ],
  },
];

export const ADDRESSES = [
  {
    id: 7001,
    name: "Lucid Member",
    phone: "0992351149",
    address: "95/151 หมู่ 3 ถนนสุขุมวิท",
    subDistrict: "เหมือง",
    district: "เมืองชลบุรี",
    province: "ชลบุรี",
    postcode: "20130",
    isDefault: true,
  },
];

export const NOTIFICATIONS = [
  { id: 1, title: "เติมเครดิตสำเร็จ", detail: "เติมเครดิต 500 บาท ผ่าน QR Payment", at: "2026-08-17 08:40", read: false },
  { id: 2, title: "คำสั่งซื้อสำเร็จ", detail: "Aether Legends 620 เพชร เติมสำเร็จ", at: "2026-08-16 22:15", read: false },
  { id: 3, title: "โปรโมชั่นใหม่", detail: "รับโบนัส 5% เมื่อเติมผ่าน Lucid Wallet", at: "2026-08-15 10:00", read: true },
];

export const COUPONS = [
  { code: "LUCID10", type: "percent", value: 10, minAmount: 0 },
  { code: "LUCID50", type: "amount", value: 50, minAmount: 300 },
];

export const ABOUT_CONTENT = {
  title: "เกี่ยวกับ LucidTopup",
  intro:
    "LucidTopup คือผู้ให้บริการเติมเกมออนไลน์ เติมเงินมือถือ และจำหน่ายบัตรเติมเงินอัตโนมัติ ตลอด 24 ชั่วโมง ด้วยระบบที่รวดเร็ว ปลอดภัย และราคาที่คุ้มค่าที่สุด",
  points: [
    { title: "ระบบอัตโนมัติ 24 ชม.", detail: "ทำรายการเสร็จภายในไม่กี่วินาที ไม่ต้องรอแอดมิน" },
    { title: "รองรับมากกว่า 200 เกม", detail: "ครอบคลุมทั้งเกมมือถือ เกม PC และเกมออนไลน์ยอดนิยม" },
    { title: "ปลอดภัยได้มาตรฐาน", detail: "ชำระเงินผ่านช่องทางที่ได้รับการรับรอง พร้อมระบบยืนยันตัวตน" },
    { title: "ทีมงานดูแลตลอดเวลา", detail: "ติดต่อทีมงานผ่าน Support Ticket ได้ตลอด 24 ชั่วโมง" },
  ],
  company: {
    name: "บริษัท ลูซิด ท็อปอัพ จำกัด",
    address: "95/151 ต.เหมือง อ.เมือง จ.ชลบุรี 20130",
    phone: "092-981-1596",
    email: "lucidtopup@gmail.com",
    line: "@lucidtopup",
  },
};

export const POLICY_SECTIONS = [
  {
    title: "1. ข้อมูลที่เราเก็บรวบรวม",
    body: [
      "ข้อมูลบัญชีผู้ใช้ ได้แก่ ชื่อบัญชี อีเมล เบอร์โทรศัพท์ และรหัสผ่านที่ถูกเข้ารหัส",
      "ข้อมูลการทำรายการ ได้แก่ ประวัติการเติมเครดิต ประวัติคำสั่งซื้อ และช่องทางการชำระเงิน",
      "ข้อมูลการใช้งาน ได้แก่ IP address อุปกรณ์ และเวลาเข้าใช้งานระบบ",
    ],
  },
  {
    title: "2. วัตถุประสงค์ในการใช้ข้อมูล",
    body: [
      "เพื่อยืนยันตัวตนและป้องกันการทุจริตในการทำรายการ",
      "เพื่อให้บริการเติมเกม เติมเงินมือถือ และจัดส่งสินค้า",
      "เพื่อแจ้งข่าวสารและสิทธิประโยชน์ต่าง ๆ ของ LucidTopup",
    ],
  },
  {
    title: "3. การเปิดเผยข้อมูลต่อบุคคลที่สาม",
    body: [
      "เราเปิดเผยข้อมูลเท่าที่จำเป็นให้กับผู้ให้บริการชำระเงินและผู้ให้บริการเกมเท่านั้น",
      "เราไม่จำหน่ายหรือให้เช่าข้อมูลส่วนบุคคลของผู้ใช้แก่บุคคลที่สามเพื่อการตลาด",
    ],
  },
  {
    title: "4. สิทธิของเจ้าของข้อมูล",
    body: [
      "ผู้ใช้สามารถขอเข้าถึง แก้ไข หรือลบข้อมูลส่วนบุคคลของตนได้",
      "ผู้ใช้สามารถขอถอนความยินยอมในการประมวลผลข้อมูลได้ตลอดเวลา",
      "ติดต่อเจ้าหน้าที่คุ้มครองข้อมูลได้ที่ lucidtopup@gmail.com",
    ],
  },
  {
    title: "5. ความปลอดภัยของข้อมูล",
    body: [
      "ข้อมูลรหัสผ่านถูกเข้ารหัสแบบทางเดียว และข้อมูลสำคัญถูกส่งผ่านการเชื่อมต่อแบบเข้ารหัส",
      "ระบบมีการบันทึกประวัติการเข้าสู่ระบบเพื่อให้ผู้ใช้ตรวจสอบความผิดปกติได้",
    ],
  },
];

export const TERMS_SUMMARY = [
  "หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าบัญชีอัตโนมัติ",
  "หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกรายการได้",
  "หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกรายการได้",
  "กรณีชำระเงินสำเร็จแต่การเติมล้มเหลว ระบบจะคืนเป็นเครดิตเข้ากระเป๋าอัตโนมัติ",
];
